import { SessionServiceErrorType } from "../../../../interfaces/session-management/enums/error-type";

export class InvalidAccessTokenError extends Error {
	constructor(message: string) {
		super(message);
		this.name = SessionServiceErrorType.INVALID_ACCESS_TOKEN_ERROR;

		Object.setPrototypeOf(this, InvalidAccessTokenError.prototype);
	}
}
